module.exports = __webpack_public_path__ + "static/media/Chapter6.9c2eb656.pdf";